import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckFast, faShieldHalved, faHeadset, faTags } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../../../Context/LanguageContext";
import "../legal/LegalPage.css";
import "./AboutUs.css";

export default function AboutUs ()
{
    const { lang } = useLanguage();
    const isAr = lang === "ar";

    const features = [
        {
            icon: faTruckFast,
            title: isAr ? "توصيل سريع" : "Fast Delivery",
            desc: isAr ? "نوصّل طلبك لكل المناطق بأسرع وقت ممكن" : "We deliver your order everywhere, fast",
        },
        {
            icon: faShieldHalved,
            title: isAr ? "دفع آمن" : "Secure Payment",
            desc: isAr ? "بياناتك ومعاملاتك محمية بالكامل" : "Your data and transactions are fully protected",
        },
        {
            icon: faTags,
            title: isAr ? "أسعار منافسة" : "Competitive Prices",
            desc: isAr ? "أفضل الأسعار على منتجات أصلية 100%" : "Best prices on 100% authentic products",
        },
        {
            icon: faHeadset,
            title: isAr ? "دعم متواصل" : "Ongoing Support",
            desc: isAr ? "فريقنا جاهز لمساعدتك في أي وقت" : "Our team is ready to help you anytime",
        },
    ];

    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1 className="legal-title">
                    { isAr ? "من نحن" : "About Us" }
                </h1>
                <p className="legal-updated">
                    { isAr
                        ? "تعرّف على قصتنا ورسالتنا"
                        : "Learn more about our story and mission" }
                </p>

                <div className="legal-section">
                    <h2>{ isAr ? "قصتنا" : "Our Story" }</h2>
                    <p>
                        { isAr
                            ? "انطلقنا برؤية بسيطة: نوفر تجربة تسوق إلكتروني سهلة وموثوقة، بمنتجات أصلية وأسعار عادلة، توصل لكل عميل بأسرع وقت ممكن. من يومها ونحن نعمل على تطوير خدماتنا باستمرار لنكون خيارك الأول في التسوق الإلكتروني."
                            : "We started with a simple vision: to provide an easy, reliable online shopping experience with authentic products and fair prices, delivered to every customer as fast as possible. Since then, we've been continuously improving our services to become your first choice for online shopping." }
                    </p>
                </div>

                <div className="legal-section">
                    <h2>{ isAr ? "رسالتنا" : "Our Mission" }</h2>
                    <p>
                        { isAr
                            ? "نسعى لتقديم تجربة تسوق استثنائية تجمع بين الجودة، السرعة، والثقة — عشان تكون رحلة تسوقك معنا سهلة وممتعة من أول ضغطة حتى استلام طلبك."
                            : "We strive to deliver an exceptional shopping experience combining quality, speed, and trust — making your journey with us easy and enjoyable from the first click to delivery." }
                    </p>
                </div>

                <div className="about-features-grid">
                    { features.map( ( f, i ) => (
                        <div className="about-feature-card" key={ i }>
                            <FontAwesomeIcon icon={ f.icon } />
                            <h3>{ f.title }</h3>
                            <p>{ f.desc }</p>
                        </div>
                    ) ) }
                </div>
            </div>
        </div>
    );
}
